export * from './getRect';
export * from './lyricParser';
export * from './classifier';
export * from './applyMiddleware';
export * from './i18n';